"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _hmacSha = _interopRequireDefault(require("crypto-js/hmac-sha256"));
var _APLabelWithText = _interopRequireDefault(require("../../common/APLabelWithText"));
var _APIcon = _interopRequireDefault(require("../../common/APIcon"));
var _clipboardHelper = _interopRequireDefault(require("../../../helpers/clipboardHelper"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./ConfirmAPIKeyModal.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('confirm-api-key');
var ConfirmAPIKeyModal = function ConfirmAPIKeyModal(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  var Permissions = props.item.Permissions;
  var nonce = window.crypto.getRandomValues(new Uint32Array(1)).toString();
  var userId = props.userId,
    showSnack = props.showSnack,
    _props$item = props.item,
    APIKey = _props$item.APIKey,
    APISecret = _props$item.APISecret;
  var renderCopyableValue = function renderCopyableValue(value, snackText, ariaLabel) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: baseClasses('value-with-copy')
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: baseClasses('value-text')
    }, value), /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: baseClasses('copy-button'),
      "aria-label": ariaLabel,
      onClick: function onClick() {
        (0, _clipboardHelper["default"])(value);
        if (showSnack) {
          showSnack({
            id: 'API_KEY_COPY',
            text: snackText
          });
        }
      }
    }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
      name: "copy",
      customClass: baseClasses('copy-icon')
    })));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('key-info-container')
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Permissions'),
    text: Permissions.join(', '),
    customClass: baseClasses()
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Key'),
    text: renderCopyableValue(APIKey, t('The API Key has been copied to the clipboard.'), t('Copy API Key')),
    customClass: baseClasses()
  }), APISecret && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Secret'),
    text: renderCopyableValue(APISecret, t('The API Secret has been copied to the clipboard.'), t('Copy API Secret')),
    customClass: baseClasses()
  }))), APISecret && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('authenticate-user')
  }, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    ns: "core"
  }, "Call ", /*#__PURE__*/_react["default"].createElement("code", null, "AuthenticateUser"), " with the following to login:")), /*#__PURE__*/_react["default"].createElement("pre", null, JSON.stringify({
    APIKey: APIKey,
    Signature: (0, _hmacSha["default"])("".concat(nonce).concat(userId).concat(APIKey), APISecret).toString(),
    UserId: userId.toString(),
    Nonce: nonce
  }, null, 2)), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    ns: "core",
    format: "NonceUserIdAPIKey"
  }, "To generate your own signature with a different nonce,", ' ', /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://codebeautify.org/hmac-generator",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "HMAC-Sha256"), ' ', "encode your nonce, user ID, and API key, in the format ", /*#__PURE__*/_react["default"].createElement("code", null, "NonceUserIdAPIKey"), " using the secret as your key.")))));
};
ConfirmAPIKeyModal.propTypes = {
  item: _propTypes["default"].object,
  index: _propTypes["default"].number,
  onRemove: _propTypes["default"].func,
  showSnack: _propTypes["default"].func
};
ConfirmAPIKeyModal.defaultProps = {
  index: 0
};
var _default = exports["default"] = ConfirmAPIKeyModal;